import { render, staticRenderFns } from "./MainAuth.vue?vue&type=template&id=09307421&scoped=true&"
import script from "./MainAuth.vue?vue&type=script&lang=js&"
export * from "./MainAuth.vue?vue&type=script&lang=js&"
import style0 from "./MainAuth.vue?vue&type=style&index=0&id=09307421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09307421",
  null
  
)

export default component.exports